module.exports = __webpack_public_path__ + "img/lisa_h_2.ce306d24.png";